import 'normalize.css';
import React from 'react';
import '../../../fonts/fonts.css';
import Head from './Head';
import IntlWrapper from './IntlWrapper';
import featureFlags from '../../featureFlags';
import GlobalStyles from './GlobalStyles';
import environment from '../../environment';

featureFlags.init({ environment });

function Layout({
  children,
  titleTag,
  descriptionTag,
  pageContext: { locale },
}) {
  return (
    <IntlWrapper locale={locale}>
      <GlobalStyles />
      <Head titleTag={titleTag} descriptionTag={descriptionTag} />
      <main>{children}</main>
    </IntlWrapper>
  );
}

export default Layout;
